import { useEffect, useState } from "react";
import { getBookedAuditionees } from "../../../../CastingBotFirebase";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";

function ViewRecalleesTab(props) {

  function filterForRecalls(x) {return x.recalled}

  const userData = props.userData;
  const castingData = props.extraData;

  const header = ['Name', 'Email', 'Phone', 'Recall Verdicts']
  const [recallees, setRecallees] = useState(null);
  var body = [];

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(castingData.slots.filter(filterForRecalls), userData.active_organisation_id, setRecallees);
    // eslint-disable-next-line
  }, []);

  if(recallees === null) return <SectionLoader />

  body = _parseToTable(recallees, castingData.slots.filter(filterForRecalls), castingData.roles);

  if(body.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        <SubTabTable header={header} body={body} />
      </SubTabParent>
    )
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Recallees' 
        description="Move people to your recall pool to see them here"
      />
    )
  }

}

export default ViewRecalleesTab;



const _parseToTable = (recallees, slots, roles) => {

  recallees.sort((a,b) => {return a.name > b.name? 1 : -1})

  var recalleesArray = [];

  recallees.forEach((recallee) => {
    var slot = null;
    slots.forEach((s) => {if(s.auditionee_id === recallee.uid) slot = s;});

    const recalls = slot.notes.recall_verdicts.sort((a,b) => {return a.role_id > b.role_id? 1 : -1});
    var data = [
      recallee.name,
      recallee.email,
      recallee.phone,
      null
    ];

    if(recalls.length === 0)
    {
      recalleesArray = [...recalleesArray, data];
    }
    else
    {
      var recallArray = [];
      recalls.forEach((recall) => {
        var role = null;
        roles.forEach((r) => { if(r.id.toString() === recall.role_id) role = r.name });
        recallArray = [...recallArray, [(<div style={{color: _getVerdictColour(recall.verdict)}}>{role}</div>)]]
      })
      data[3] = recallArray;
      recalleesArray = [...recalleesArray, data];
    }
  })

  console.log(recalleesArray);

  return recalleesArray;
}

const _getVerdictColour = (verdict) => {
  if      (verdict === 'undetermined')    return '#cccccc'; // Light grey
  else if (verdict === 'poor')            return '#e74c3c'; // Red
  else if (verdict === 'ok')              return '#e67e22'; // Orange
  else if (verdict === 'good')            return '#f1c40f'; // Yellow
  else                                    return '#2ecc71'; // Green
}